// extracted by mini-css-extract-plugin
export default {"userMenu":"UserMenu_userMenu__Stk7D","avatar":"UserMenu_avatar__sRg9V","welcomeText":"UserMenu_welcomeText__ByEJZ","btnLogOut":"UserMenu_btnLogOut__if2se"};